import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { courseService } from "../../../_services";
import CourseChapter from "../../Courses/CourseDetails/CourseChapterDetails/CourseChapter";
import Faq from "../../Faq/Faq";
import Reviews from "../Reviews/Reviews";
import AdmissionDetails from "./AdmissionDetails";
import AdmissionFeeAndFinancing from "./AdmissionFeeAndFinancing";
import ApplicationModal from "./ApplicationModal";
import CareerSupport from "./CareerSupport";
import CourseOverview from "./CourseOverView";
import Carousel from "../../Other/Carousel/Carousel"
import IndustryProjects from "./IndustryProjects";
import LearningExperience from "./LearningExperience";
import LearningPath from "./LearnPath";
import ProgramDetails from "./ProgramDetails";
import SkillsCovered from "./SkilledCovered";
import ToolCovered from "./ToolCovered";
import WhyJoinThisProgram from "./WhyJoinThisProgram";
import CertificateAdvantages from "./CertificateAdvantages";
import ProgramCohortHighlights from "./ProgramCohortHighlights";
import YourCareer from "./YourCareer";
import ProgramAdvisorsAndTrainers from "./ProgramAdvisorsAndTrainers";
import IndustryTrends from "./IndustryTrends";
import CompaniesHiring from "./CompaniesHiring";
import BatchProfile from "./BatchProfile";
import ProgramCohorts from "./ProgramCohorts";

import { courseActions } from "@/_actions";
import { addWishlist, deleteWishlist } from "@/_actions/cart.actions";
import { CourseSeo } from "@/_components/fetchSeoMeta";
import Share from "@/pages/Courses/CourseShare/courseShare";
import CartButton from "@/pages/Courses/CourseTile/CartButton/CartButton";
import { CheckCircle, Download, Heart } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FaShare } from "react-icons/fa";
import axiosInstance from "../../../axios";
import EnrollCourse from "./EnrollCourse";
// Section Data
const sectionIds = [
  { id: "overviews", name: "Overview" },
  { id: "programdetails", name: "Program Details" },
  { id: "admission", name: "Admission" },
  { id: "pricing", name: "Pricing" },
  { id: "careersupport", name: "Career Support" },
  { id: "faqs", name: "FAQs" },
];

function Navigation({
  activeSection,
  course,
  loggedIn,
  courses,
  user,
  modalOpen,
  setModalOpen,
  modalOpen1,
  setModalOpen1,
}) {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [favourite, setFavourite] = useState(Boolean(courses?.isWishlisted));
  const [shareShow, setShareShow] = useState(false);

  useEffect(() => {
    setFavourite(Boolean(courses?.isWishlisted));
  }, [courses]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 120; // Account for fixed header
      const elementPosition = element.offsetTop;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };
  const likeHandler = (courseId, isWishlisted) => {
    if (loggedIn && favourite) {
      dispatch(courseActions.handleResetCourseList());
      dispatch(deleteWishlist(courseId));
      setFavourite(false);
    } else if (loggedIn && !favourite) {
      dispatch(courseActions.handleResetCourseList());
      dispatch(addWishlist(courseId));
      setFavourite(true);
    }
     else {
      navigate("/login");
    }
    // onClickTabItem(activeTab, courseId);
  };
  const handleClose = () => {
    setShareShow(!shareShow);
  };
  const syllabusHref =
    courses?.courseFiles?.length > 0
      ? `https://pub-561e50d39a1c4c3a9c5d9a7715790c10.r2.dev/${courses.courseFiles[0].fileName}`
      : "#";

  return (
    <nav className="pd-nav-container">
      <div className="pd-nav-wrapper">
        <div className="pd-nav-content">
          <ul className="pd-nav-tabs">
            {sectionIds.map((item) => (
              <li key={item.id} className="flex-shrink-0 h-full flex items-center">
                <button
                  onClick={() => scrollToSection(item.id)}
                  className={`pd-nav-tab-btn ${activeSection === item.id ? "active" : ""}`}
                >
                  {item.name}
                  {activeSection === item.id && (
                    <span className="active-indicator" />
                  )}
                </button>
              </li>
            ))}
          </ul>
          <div className="pd-nav-actions">
            <a
              href={loggedIn ? syllabusHref : "#"}
              target={loggedIn ? "_blank" : "_self"}
              rel="noopener noreferrer"
              onClick={(e) => { if (!loggedIn) { e.preventDefault(); navigate("/register"); } }}
              className="pd-nav-btn-syllabus"
            >
              <Download className="w-3.5 h-3.5" />
              Syllabus
            </a>

            {!loggedIn ? (
              <button
                onClick={() => navigate("/register")}
                className="pd-nav-btn-apply"
              >
                Apply Now
              </button>
            ) : Number(user?.role) === 2 ? (
              !courses?.isPurchased ? (
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => setModalOpen1(true)}
                    className="pd-nav-btn-buy"
                  >
                    Buy Now
                  </button>
                  <CartButton post={course} />
                </div>
              ) : (
                <button className="pd-nav-btn-enrolled">
                  <CheckCircle className="w-3.5 h-3.5" />
                  Enrolled
                </button>
              )
            ) : (
              <button className="pd-nav-btn-enrolled">
                <CheckCircle className="w-3.5 h-3.5" />
                Enrolled
              </button>
            )}
            {loggedIn && (
              <button
                onClick={() => likeHandler(course.ID, courses?.isWishlisted)}
                className={`pd-nav-wishlist-btn ${favourite ? "wishlisted" : ""}`}
                title={favourite ? "Remove from wishlist" : "Add to wishlist"}
              >
                <Heart className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      </div>

      <ApplicationModal isOpen={modalOpen} onClose={() => setModalOpen(false)} courseId={course.ID} CourseName={course.CourseName} />
      <EnrollCourse isOpen={modalOpen1} onClose={() => setModalOpen1(false)} courseId={course.ID} CourseName={course.CourseName} EnrollFees={course.EnrollmentFee} />
      {shareShow && <Share handleClose={handleClose} />}
    </nav>
  );
}

function Sections({
  propSlug,
  course,
  fetchCourse,
  loggedIn,
  courses,
  user,
  modalOpen,
  setModalOpen,
  modalOpen1,
  setModalOpen1,
}) {

  const { t } = useTranslation();
  const [stats, setStats] = useState(courses?.courseSections);
  const TimeConversion = (value) => {
    value = Number(value);
    var hour = Math.floor(value / 3600);
    var min = Math.floor((value % 3600) / 60);
    var second = Math.floor((value % 3600) % 60);

    var hourValue = hour > 0 ? hour + (hour == 1 ? " hour " : " hours") : "";
    var minValue = min > 0 ? min + (min == 1 ? " min " : " mins") : "";
    var secondValue =
      second > 0 ? second + (second == 1 ? "second" : "seconds") : "";

    if (hourValue) {
      return hourValue + " " + minValue;
    } else if (minValue) {
      return minValue;
    } else return secondValue;
  };

  const ProgressData = async (courseId) => {
    try {
      const response = await axiosInstance.get(`course/${courseId}`);
      setStats(response?.data?.data?.courseSections);
    } catch (error) {
      console.log(error);
    }
  };
  const updateChapterData = (id, isFinished) => {
    setStats((prevStats) => {
      if (!Array.isArray(prevStats)) return prevStats; // or return []

      const updatedStats = prevStats.map((ele) =>
        ele.id === id ? { ...ele, isFinished } : ele
      );

      return updatedStats;
    });
  };



  const groupedBySyllabus = {};
  const courseSections = (courses && Array.isArray(courses.courseSections)) ? courses.courseSections : [];

  courseSections?.forEach((section) => {
    const { syllabusId, syllabusName, mainTitle } = section;

    // Initialize syllabus group if not present
    if (!groupedBySyllabus[syllabusId]) {
      groupedBySyllabus[syllabusId] = {
        syllabusName: syllabusName,
        mainTitles: {}, // Use object to track unique mainTitles
      };
    }

    // Initialize mainTitle group inside syllabus if not present
    if (!groupedBySyllabus[syllabusId].mainTitles[mainTitle]) {
      groupedBySyllabus[syllabusId].mainTitles[mainTitle] = {
        mainTitle: mainTitle,
        sections: [],
      };
    }

    // Push section under the correct mainTitle group
    groupedBySyllabus[syllabusId].mainTitles[mainTitle].sections.push(section);
  });

  return (
    <div>
      <div className="dashboard-container-new !mb-2">
      </div>
      <ProgramDetails
        propSlug={propSlug}
        course={course}
        fetchCourse={fetchCourse}
        loggedIn={loggedIn}
        courses={courses}
        user={user}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalOpen1={modalOpen1}
        setModalOpen1={setModalOpen1}
      />
      {!propSlug && (<WhyJoinThisProgram
        course={course}
        loggedIn={loggedIn}
        courses={courses}
        user={user}
      />)}
      {!propSlug && (<ProgramCohortHighlights />)}
      {!propSlug && (<YourCareer />)}
      {!propSlug && (<CourseOverview course={course} fetchCourse={fetchCourse} />)}
      <CertificateAdvantages course={course}/> 

      {!propSlug && (<>
        {loggedIn && courses?.isPurchased ? (
          // <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          //   <div className="section-title font-bold text-3xl font-bold mb-4">
          //     {t("Course Content")}
          //   </div>
          //   {/* <div className="pro-bar-width">
          //     {courses.isPurchased && <CoursePercentage course={stats} />}
          //   </div> */}
          //   <div className="space-y-6 ">
          //     {/* {Object.entries(groupedBySyllabus).map(([syllabusId, syllabusData], syllabusIndex) => (
          //       <div key={syllabusId} className="bg-gray-50 p-4 rounded-lg shadow-sm mb-6">
          //         <h2 className="text-xl font-semibold text-blue-600 mb-4">
          //           {syllabusIndex + 1}: {syllabusData.syllabusName}
          //         </h2> */}

          //     {/* Loop through mainTitles */}
          //     {/* {Object.entries(syllabusData.mainTitles).map(([mainTitleKey, mainTitleData], mainTitleIndex) => (
          //           <div key={mainTitleKey} className="mb-4 ml-4">
                      
          //             <h3 className="text-lg font-medium text-gray-800 mb-2">
          //               {mainTitleIndex + 1}. {mainTitleData.mainTitle}
          //             </h3> */}

          //     {/* Section Cards */}
          //     <div className="space-y-4"> 
          //       {courses?.courseSections.map((section, index) => (
          //         <CourseChapter
          //           index={index}
          //           mainTitle={section?.mainTitle}
          //           title={section?.sectionName}
          //           content={section?.sectionDescription}
          //           view={section?.files}
          //           scroms={section?.scroms}
          //           acknowledge={section?.isFinished}
          //           status={courses?.isPurchased}
          //           TimeConversion={TimeConversion}
          //           ID={section?.courseID}
          //           sectionId={section?.id}
          //           updateChapterData={updateChapterData}
          //           fetchData={ProgressData}
          //           videoLink={section?.videoLink}
          //           syllabusId={section?.syllabusId}
          //           syllabusName={section?.syllabusName}
          //         />
          //       ))}
          //     </div>
          //     {/* </div>
          //         ))} */}
          //     {/* </div>
          //     ))} */}
          //   </div>

          // </div>
          <>
            <LearningPath course={course} fetchCourse={fetchCourse} />
          </>
        ) : (
          <>
            <LearningPath course={course} fetchCourse={fetchCourse} />
          </>
        )}
      </>)}

      {!propSlug && (<SkillsCovered fetchCourse={fetchCourse} />)}
      {!propSlug && (<ToolCovered course={course} />)}
      {!propSlug && (<AdmissionDetails fetchCourse={fetchCourse} />)}

      <AdmissionFeeAndFinancing
        fetchCourse={fetchCourse}
        loggedIn={loggedIn}
        courses={courses}
        user={user}
      />
      {!propSlug && (<IndustryProjects fetchCourse={fetchCourse} />)}
      {!propSlug && (<LearningExperience />)}
      {!propSlug && (<ProgramAdvisorsAndTrainers fetchCourse={fetchCourse}/>)}
      {!propSlug && (<CareerSupport />)}
      {!propSlug && (<IndustryTrends />)}
      {!propSlug && (<CompaniesHiring />)}
      {!propSlug && (<BatchProfile />)}
      {!propSlug && (<ProgramCohorts course={course} />)}
      {!propSlug && (<Reviews courseId={course?.ID} reviews={courses?.reviews} />)}
      <Carousel course={course} isPurchased={!!(loggedIn && (courses?.isPurchased || user?.role === 1 || user?.role === "1"))} />
      {!propSlug && (<Faq fetchCourse={fetchCourse} />)}
      {/* <OtherCities courseData={course} cities={cities} /> */}
      {/* {filteredCourses && filteredCourses.length > 0 &&
        <RelatedCourse courseData={course} filteredCourses={filteredCourses} AllCourse={AllCourse} navigate={navigate} />
      } */}
    </div>
  );
}

function Programs({ slug: propSlug, course: propCourse }) {

  const { slug: paramSlug } = useParams();
  const slug = propSlug || paramSlug;
  const dispatch = useDispatch()
  const { loggedIn } = useSelector((state) => state.authentication);
  const { user } = useSelector((state) => state.users);
  const [activeSection, setActiveSection] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  const { course: paramCourse } = location.state || {};

  // Router navigation state (paramCourse) and props (propCourse) are only
  // populated when you arrive here by clicking a link inside the app. A
  // direct hit, page refresh, or shared link on a program URL has neither -
  // it only has the slug from the URL. slugFetchedCourse is the fallback
  // for that case: resolved below via courseService.fetchCourseBySlug.
  const [slugFetchedCourse, setSlugFetchedCourse] = useState(null);
  // Start as "resolving" on a direct hit, so the redirect-to-home effect below
  // doesn't fire on the first render before the slug lookup has even started.
  const [resolvingBySlug, setResolvingBySlug] = useState(
    () => !paramCourse && !propCourse && Boolean(slug)
  );
  const course = paramCourse || propCourse || slugFetchedCourse;

  const [fetchCourse, setFetchCourse] = useState();
  const [courses, setCourse] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);

  useEffect(() => {
    // Already have the course via nav state/props, or there's no slug to
    // look up (shouldn't happen on this route, but be defensive) - nothing
    // to resolve.
    if (paramCourse || propCourse || !slug) {
      return;
    }

    let cancelled = false;
    setResolvingBySlug(true);

    (async () => {
      try {
        const data = await courseService.fetchCourseBySlug(slug);
        if (!cancelled && data) {
          setSlugFetchedCourse(data);
        }
      } catch (err) {
        console.log("error resolving course by slug", err);
      } finally {
        if (!cancelled) setResolvingBySlug(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [slug, paramCourse, propCourse]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const data = await courseService.fetchCourseById("course", course?.ID);
        setFetchCourse(data);
        setCourse(data);
      } catch (err) {
        console.log("errorr", err);
      }
    };

    if (course) {
      fetchCourses();
    }
  }, [course]);

  useEffect(() => {
    // Don't redirect while the slug lookup above is still in flight - only
    // once it's finished and genuinely couldn't find a matching course.
    if (!course && !resolvingBySlug) {
      navigate("/");
    }
  }, [course, resolvingBySlug, navigate]);

  useEffect(() => {
    const updateViews = async () => {
      try {
        if (course?.ID) {
          await axiosInstance.post(`course/${course.ID}/views`);
        }
      } catch (error) {
        console.error("Error updating course views:", error);
      }
    };

    updateViews();
  }, [course?.ID]);


  useEffect(() => {
    const handleScroll = () => {
      let current = "";
      const scrollPosition = window.scrollY + 150; // Offset for fixed header

      for (const { id } of sectionIds) {
        const section = document.getElementById(id);
        if (section) {
          const sectionTop = section.offsetTop;
          const sectionBottom = sectionTop + section.offsetHeight;

          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            current = id;
          }
        }
      }

      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Set initial active section

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  if (!course) {
    return null; // safe conditional rendering after all hooks
  }
  return (
    <div>
      {!propSlug && <CourseSeo course={courses || course} />}
      {!propSlug && (
        <Navigation
          activeSection={activeSection}
          course={course}
          loggedIn={loggedIn}
          courses={courses}
          user={user}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          modalOpen1={modalOpen1}
          setModalOpen1={setModalOpen1}
        />)}
      <Sections
        propSlug={propSlug}
        course={course}
        fetchCourse={fetchCourse}
        loggedIn={loggedIn}
        courses={courses}
        user={user}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalOpen1={modalOpen1}
        setModalOpen1={setModalOpen1}
      />
    </div>
  );
}

export default Programs;
